import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button'];

  copy() {
    const checkboxes = document.querySelectorAll('.user-email-checkbox:checked');
    const emails = Array.from(checkboxes)
      .map((cb) => cb.getAttribute('data-user-email'))
      .filter((email) => email && email.trim() !== '');

    if (emails.length === 0) {
      alert('Please select at least one user to copy emails.');
      return;
    }

    const emailString = emails.join(', ');
    navigator.clipboard
      .writeText(emailString)
      .then(() => {
        const button = this.hasButtonTarget ? this.buttonTarget : document.getElementById('copy-emails-button');
        if (button) {
          const originalText = button.innerHTML;
          button.innerHTML = 'Copied Successfully';
          setTimeout(() => {
            button.innerHTML = originalText;
          }, 2000);
        }
      })
      .catch((err) => {
        console.error('Failed to copy emails:', err);
        alert('Failed to copy emails to clipboard.');
      });
  }
}
